export default "__VITE_ASSET__8NA2_HCJ__"